import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { ContentCategory } from '@/core/api/entities/contentCategory'
import { ContentCategoryMapper } from '@/core/api/mappers/contentCategoryMapper'
import contentCategoryService from '@/core/api/services/contentCategoryService'

export function useContentCategories({
	config,
	options,
}: any = {}): UseQueryResult<ContentCategory[], Error> {
	const QUERY_KEY = [
		'content_categories',
		{
			...config?.params,
		},
	]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			contentCategoryService
				.getContentCategories(config)
				.then(({ data }) => ContentCategoryMapper.toEntities(data.data)),
		...options,
		cacheTime: 86400000, // 24h
		staleTime: 86400000, // 24h
	})
}
